(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('util', [
    '$rootScope',
    'downgradedUserService',
    '$window',
    'commonService',
    'provinceMeta',
    '$http',
    '$state',
    '$q',
    'uteEndpoint',
    'uteModal',
    '$modalStack',
    '$timeout',
    'timerService',
    function(
      $rootScope,
      downgradedUserService,
      $window,
      commonService,
      provinceMeta,
      $http,
      $state,
      $q,
      uteEndpoint,
      uteModal,
      $modalStack,
      $timeout,
      timerService
    ) {
      return {
        // is available province -- usually to validate redirection via url to particular province
        isValidProvince: function(province) {
          return provinceMeta[province] ? true : false;
        },

        // is valid language
        isValidLanguage: function(language) {
          return ['en', 'fr'].indexOf(language.toLowerCase()) !== -1 ? true : false;
        },

        isPromise: function(obj) {
          return !!obj && angular.isFunction(obj.then);
        },

        // start agent session
        startAgentSession: function() {
          var deferred = $q.defer();
          var $this = this;

          // make blank call to endpoint to get session info (cfa)
          $http({
            method: 'GET',
            url: uteEndpoint('v1/cfaInfo'),
            cache: false
          })
            .success(function(data, status) {
              // data.cfaInfo = {"province":"ON","language":"en","jSessionID":"hTBdVQnbZkGK62GHRbjXDZf2CYTB1VkqQ7n2tTJtxpkd33n0v9CS!257750106!1434480187778","sourceURL":"https://dev09.ssp.fido.ca","signOutURL":"/shop/home","closeAccountURL":"/shop/home","accountNumber":"210920088","targetURL":"FOVERVIEW","heartBeatURL":"/shop/o/logout-keep-alive","uteHeartBeatURL":"/v1/cfaHb","agentName":"sheela bhogadi","getCustomerAccounts":{"firstName":"prasfido","lastName":"hsi","error":"","accounts":[{"accountNumber":"210920088","status":"OPEN","serviceName":"Internet/TV"}]}};
              // console.log('cfaInfo', data.cfaInfo);

              if (!data.cfaInfo) {
                deferred.reject('No cfaInfo');
                return;
              }

              // declare new userInfo
              $rootScope.userInfo = {
                cfaInfo: data.cfaInfo,
                type: 'cfa'
              };

              commonService.resetServiceDataDone = false;
              commonService.loggingOut = false;

              // if there is user context
              if (data.cfaInfo.getCustomerAccounts) {
                $rootScope.userInfo.accounts = $rootScope.userInfo.cfaInfo.getCustomerAccounts.accounts
                  ? $rootScope.userInfo.cfaInfo.getCustomerAccounts.accounts
                  : [];
                $rootScope.userInfo.firstName = $rootScope.userInfo.cfaInfo.getCustomerAccounts.firstName
                  ? $rootScope.userInfo.cfaInfo.getCustomerAccounts.firstName
                  : '';
                $rootScope.userInfo.lastName = $rootScope.userInfo.cfaInfo.getCustomerAccounts.lastName
                  ? $rootScope.userInfo.cfaInfo.getCustomerAccounts.lastName
                  : '';
                $rootScope.userInfo.profileType = $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
                  ? $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
                  : '';

                //Update the serviceName
                if (($rootScope.userInfo.accounts || []).length > 0) {
                  _.each($rootScope.userInfo.accounts, function(account) {
                    if (account.serviceName === 'Internet') {
                      account.serviceName = 'Internet/TV';
                    }
                  });
                }

                console.log('$rootScope.userInfo', $rootScope.userInfo);
              }

              downgradedUserService.cfaLogin($rootScope.userInfo);

              // make call to get more details on the customer accounts
              commonService.getAccountDetails($rootScope.userInfo.accounts, true);

              console.log('CFA has Cx context:', $rootScope.ruiMethods.agent.has.customerContext());
              // start timer
              $this.renewAgentSession();

              // Added to stop the timer for the agent
              timerService.stopTimer();

              // return
              deferred.resolve(data);
            })
            .error(function(data, status) {
              deferred.reject(data);
            });

          return deferred.promise;
        },

        // parse agent timer
        parseAgentTimer: function(t) {
          var days, hours, minutes, seconds;
          days = Math.floor(t / 86400);
          t -= days * 86400;
          hours = Math.floor(t / 3600) % 24;
          t -= hours * 3600;
          minutes = Math.floor(t / 60) % 60;
          t -= minutes * 60;
          seconds = t % 60;

          if (minutes < 10) {
            minutes = '0' + minutes;
          }

          if (seconds < 10) {
            seconds = '0' + seconds;
          }

          return [minutes + ':', seconds].join('');
        },

        // renew agent session
        renewAgentSession: function(timeNow) {
          if (_.isEmpty($rootScope.userInfo)) {
            return;
          }

          $rootScope.userInfo.expiry = moment()
            .add(15, 'minutes')
            .toDate();

          // send heartbeats; one for ssp and the other for ute
          $http.post(
            $rootScope.userInfo.cfaInfo.sourceURL +
              $rootScope.userInfo.cfaInfo.heartBeatURL +
              ';jsessionid=' +
              $rootScope.userInfo.cfaInfo.jSessionID
          );
          var heartBeatURL = $rootScope.userInfo.cfaInfo.uteHeartBeatURL;

          if (heartBeatURL && heartBeatURL.substring(0, 1) === '/') {
            $http.post(uteEndpoint($rootScope.userInfo.cfaInfo.uteHeartBeatURL.substring(1)));
          }
        },

        // end user session
        endAgentSession: function() {
          console.log('inside endAgentSession, logging out.');
          $state.go('logout', { cfaLoggingOut: true });
        },
        formatPhoneNumber: function(number) {
          if (typeof number === 'undefined' || number === null) {
            return number;
          }
          if (number.indexOf('.') > 0) {
            number = number.split('.').join('');
          } else if (number.indexOf(' ') > 0) {
            number = number.split(' ').join('');
          } else if (number.indexOf('-') > 0) {
            number = number.split('-').join('');
          }

          return number;
        },

        objectToArray: function(obj) {
          var arr = [];
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              console.log('o.' + prop + ' = ' + obj[prop]);
              arr.push(obj[prop]);
            }
          }

          return arr;
        },

        // use this method to add window objects (declared in cookieRead) to $rootScope with watches to store back into cookies
        setCookiesOnRootScope: function(cookiesToSet) {
          _.each(cookiesToSet, function(cookieToSet) {
            $rootScope[cookieToSet.rootScopeVarName] = $window[cookieToSet.windowObjName];
            $rootScope.$watch(cookieToSet.rootScopeVarName, cookieToSet.watchMethod, cookieToSet.deepWatch);
          });
          return;
        },

        arrayToObject: function(arr) {
          var obj = {};
          arr.forEach(function(ele, index) {
            obj[index] = ele;
          });
          return obj;
        },

        clearLocalStorageValue: function() {
          /* set keys that you do not wat to be deleted from local storage
         ngStorage does not work with janrain
         */
          var keepKeys = ['janrainCaptureReturnExperienceData', 'janrainCaptureReturnExperienceData_Expires'];
          var keyValue = {};

          $.each(keepKeys, function(index, key) {
            keyValue[key] = $window.localStorage.getItem(key);
          });

          $window.localStorage.clear();

          $.each(keepKeys, function(index, key) {
            // localStorage.setLocalStorageValue(key,keyValue[key]);
            $window.localStorage.setItem(key, keyValue[key]);
          });
        },

        getParameterByName: function(name) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(location.href.replace('&amp;', '&'));
          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },

        getWcocParameterByName: function(name) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&]*)'),
            results = regex.exec(location.href.replace('&amp;', '&'));
          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },

        getDeeplink: function(name) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&]*)'),
            //results = regex.exec(location.href.replace('&amp;', '&'));
            results = location.href.split('&referer=');
          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        getCCType: function(ccNumber) {
          if (ccNumber.length > 3) {
            if (ccNumber.match(/^(34|37)/)) {
              return 'AMEX';
            } else if (ccNumber.match(/^(4[0-9])/)) {
              return 'VISA';
            } else if (ccNumber.match(/^5[1-5]/)) {
              return 'MASTER';
            }
          } else if (ccNumber.length < 3) {
            return '';
          }
        },
        validateFormOnSubmit: function(formValue) {
          /* function being used to make form to display postback results */
          // dont submit if form is invalid and allow angular to show form invalid messages
          if (formValue.$invalid) {
            for (var field in formValue) {
              // look at each form input with a name attribute set
              // checking if it is pristine and not a '$' special field
              if (field[0] != '$' && formValue[field].$pristine) {
                console.log(field);
                formValue[field].$setTouched();
              }
            }
            return false;
          }
          return true;
        },
        setCacheVariable: function(variable, value) {
          /* set cache variable here, used to use accross the different controlleres */

          this[variable] = value;
          return true;
        },

        getCacheVariable: function(variable) {
          /* get cache variable here */
          return this[variable];
        },
        detectBrowser: function() {
          var browser = {};
          var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
          if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            browser.type = 'ie';
            browser.version = tem[1] || '';
            return browser;
          }
          if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null)
              return tem
                .slice(1)
                .join(' ')
                .replace('OPR', 'Opera');
          }
          M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
          if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
          browser.type = M[0].toLowerCase();
          browser.version = M[1];
          return browser;
        },
        calculateAge: function(birthDate) {
          // Format is mm/dd/yyyy
          birthDate = new Date(birthDate);
          var currentDate = new Date();
          var years = currentDate.getFullYear() - birthDate.getFullYear();

          if (
            currentDate.getMonth() < birthDate.getMonth() ||
            (currentDate.getMonth() == birthDate.getMonth() && currentDate.getDay() < birthDate.getDay())
          ) {
            years--;
          }

          return years;
        },
        extractServerError: function(error) {
          try {
            if (angular.isString(error)) {
              var matches = error.match(/(<body>)([\s\S]*.*)(<\/body>)/i);
              if (matches && matches.length > 2) {
                return this.htmlToText(matches[2])
                  .replace(/\r?\n|\r/g, '.')
                  .replace(/\t/g, '');
              } else {
                return '';
              }
            } else {
              return '';
            }
          } catch (e) {
            return e.message;
          }
        },
        htmlToText: function(htmlText) {
          return htmlText ? String(htmlText).replace(/<[^>]+>/gm, '') : '';
        },
        dismissAllModals: function() {
          $modalStack.dismissAll();
        },
        bindBodyClickToHideSection: function(scope, showHideModel, openingElementId, openedContainerId) {
          $('body').on('click', function(event) {
            if (
              scope[showHideModel] &&
              !$(event.target).is(openingElementId) &&
              !$(event.target).parents(openedContainerId).length > 0
            ) {
              scope[showHideModel] = !scope[showHideModel];
            }
          });
        }
      };
    }
  ]);
})();
